import { render, staticRenderFns } from "./DecemberPromoPopup.vue?vue&type=template&id=49b77676&"
import script from "./DecemberPromoPopup.vue?vue&type=script&lang=js&"
export * from "./DecemberPromoPopup.vue?vue&type=script&lang=js&"
import style0 from "./DecemberPromoPopup.vue?vue&type=style&index=0&id=49b77676&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b77676')) {
      api.createRecord('49b77676', component.options)
    } else {
      api.reload('49b77676', component.options)
    }
    module.hot.accept("./DecemberPromoPopup.vue?vue&type=template&id=49b77676&", function () {
      api.rerender('49b77676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DecemberPromoPopup.vue"
export default component.exports